module.exports = __webpack_public_path__ + "img/icon_bronte_head_lg.4a0fa486.png";